const trimSlashes = (value = "") =>
  String(value)
    .trim()
    .replace(/^\/+|\/+$/g, "");

export const buildSeoPath = (...segments) => {
  const normalizedSegments = segments
    .map((segment) => trimSlashes(segment))
    .filter(Boolean);

  return normalizedSegments.length > 0
    ? `/${normalizedSegments.join("/")}`
    : "/";
};

export const getCategoryIdFromProductData = (productData) => {
  const category = productData?.category;

  if (Array.isArray(category)) {
    return category[0]?.id ?? null;
  }

  return category?.id ?? null;
};
